/**
 * Trader API V1
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
export var TargetedOfferProductTag;
(function (TargetedOfferProductTag) {
    TargetedOfferProductTag.TargetedOfferTypeEnum = {
        Unknown: 'Unknown',
        AmountOff: 'AmountOff',
        Multibuy: 'Multibuy',
        PercentageOff: 'PercentageOff',
        BonusProduct: 'BonusProduct',
        OnecardPoints: 'OnecardPoints',
        FuelCentsOff: 'FuelCentsOff',
        FixedAmount: 'FixedAmount',
        BasketAmountOff: 'BasketAmountOff',
        BasketOnecardPoints: 'BasketOnecardPoints',
        BasketFuelCentsOff: 'BasketFuelCentsOff',
        BasketMultiplier: 'BasketMultiplier',
        BasketTiered: 'BasketTiered',
        LocalAreaBasketAmountOff: 'LocalAreaBasketAmountOff',
        LocalAreaBasketOnecardPoints: 'LocalAreaBasketOnecardPoints',
        LocalAreaBasketFuelCentsOff: 'LocalAreaBasketFuelCentsOff',
        LocalAreaBasketMultiplier: 'LocalAreaBasketMultiplier',
        LocalAreaBasketTiered: 'LocalAreaBasketTiered',
        CategoryFood: 'CategoryFood',
        CategoryFuel: 'CategoryFuel'
    };
})(TargetedOfferProductTag || (TargetedOfferProductTag = {}));
